import { render, staticRenderFns } from "./AgSwitch.vue?vue&type=template&id=da3a2988"
import script from "./AgSwitch.vue?vue&type=script&lang=js"
export * from "./AgSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports